function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var React = require("react");

var styled = require("styled-components").default;

var tag = require("tag-hoc").default;

var NavigationLabel = require("../navigation-label");

var NavigationItem = require("../navigation-item");

var Flag = require("@patternplate/component-flag").Flag;

module.exports = NavigationTree;

function NavigationTree(props) {
  return React.createElement(StyledNavigationTree, {
    className: props.className,
    visible: props.visible,
    "data-toggle-name": props.name,
    "data-toggle-enabled": props.visible
  }, props.children, (props.data || []).filter(function (item) {
    return _typeof(item.manifest) === "object";
  }).map(function (item, index) {
    // TODO: this should not have to deal with normalization
    var options = item.manifest.options || {};
    var hidden = options.hidden || false;
    var icon = selectSymbol(item);
    var iconActive = selectActiveSymbol(item);
    var name = selectName(item);
    var enabled = (props.query || {})["".concat(name, "-enabled")] === "true";

    switch (item.type) {
      case "folder":
        return React.createElement(React.Fragment, {
          key: item.id
        }, React.createElement(NavigationLabel, {
          visible: (item.children || []).length > 0,
          enabled: enabled,
          name: name,
          highlight: false,
          size: "M"
        }, item.manifest.displayName || item.manifest.name), React.createElement(NavigationItemList, {
          "data-toggle-name": name,
          "data-toggle-enabled": (item.children || []).length > 0 && enabled,
          visible: (item.children || []).length > 0 && enabled
        }, (item.children || []).map(function (child, index) {
          return React.createElement(NavigationItem, {
            key: child.id,
            active: child.active,
            href: child.href,
            id: child.id,
            meta: (child.warnings || []).map(function (warning) {
              return React.createElement(NavigationMeta, {
                key: warning.value,
                warning: warning
              });
            }),
            name: child.manifest.displayName,
            nested: true,
            onClick: props.onItemClick,
            onScrollRequest: props.onScrollRequest,
            prefix: props.prefix,
            symbol: selectSymbol(child),
            symbolActive: selectActiveSymbol(child),
            type: child.type
          });
        })));

      case "item":
        return React.createElement(NavigationItem, {
          key: item.id,
          active: item.active,
          hidden: hidden,
          href: options.href || item.href,
          external: Boolean(options.href),
          id: item.id,
          meta: (item.warnings || []).map(function (warning) {
            return React.createElement(NavigationMeta, {
              key: warning.value,
              warning: warning
            });
          }),
          name: item.manifest.displayName,
          onClick: props.onItemClick,
          onScrollRequest: props.onScrollRequest,
          prefix: props.prefix,
          symbol: icon,
          symbolActive: iconActive,
          type: item.type
        });
    }
  }));
}

var StyledNavigationTree = styled(tag(["visible"])("div")).withConfig({
  displayName: "navigation-tree__StyledNavigationTree"
})(["display:", ";&[data-toggle-enabled=\"false\"]{display:none;}&[data-toggle-enabled=\"true\"]{display:block;}"], function (props) {
  return props.visible ? "block" : "none";
});
var NavigationItemList = styled(tag(["visible"])("div")).withConfig({
  displayName: "navigation-tree__NavigationItemList"
})(["display:", ";&[data-toggle-enabled=\"false\"]{display:none;}&[data-toggle-enabled=\"true\"]{display:block;}"], function (props) {
  return props.visible ? "block" : "none";
});

function NavigationMeta(props) {
  switch (props.warning.type) {
    case "flag":
    default:
      return React.createElement(Flag, {
        title: props.warning.message
      }, props.warning.value);
  }
}

function selectActiveSymbol(item) {
  if (item.type === "item") {
    return null;
  }

  if (item.manifest.options.iconActive) {
    return item.manifest.options.iconActive;
  }

  if (item.type === "folder") {
    return "arrow-down";
  }

  return null;
}

function selectSymbol(item) {
  if (item.type === "item") {
    return null;
  }

  if (item.manifest.options.icon) {
    return item.manifest.options.icon;
  }

  if (item.type === "folder") {
    return "arrow-right";
  }

  return null;
}

function selectName(item) {
  if (typeof item.manifest.name === "string" && item.manifest.name) {
    return item.manifest.name;
  }

  if (typeof item.manifest.displayName === "string" && item.manifest.displayName) {
    return encodeURIComponent(item.manifest.displayName.replace(/[^\w]/g, '-').toLowerCase());
  }

  return encodeURIComponent(item.id.replace(/[^\w]/g, '-').toLowerCase());
}
//# sourceMappingURL=index.js.map